export default "__VITE_ASSET__DX0Bm8yg__"